import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DictionaryFab from "@/components/DictionaryFab";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ToolPage from "@/pages/ToolPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import { fetchCategories } from "@/lib/api";

function App() {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        fetchCategories()
            .then(setCategories)
            .catch(() => {});
    }, []);

    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/category/:slug" element={<CategoryPage />} />
                    <Route path="/tool/:slug" element={<ToolPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
                <DictionaryFab />
                <Footer categories={categories} />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        className:
                            "!bg-white !text-black !border-2 !border-black !shadow-[4px_4px_0px_#0A0A0A] !rounded-xl !font-bold",
                    }}
                />
            </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
